import { FormFieldId } from 'state/formData';
import type { Collection } from 'state/utils/types';

export function buildProductDescriptionKey(formValues: Collection<unknown>): string {
  // TODO repair with Unit Test
  return formValues['ProductSubtype' satisfies FormFieldId] as string;
}

export function getInstrumentName(formValues: Collection<unknown>): string {
  return formValues['ProductType' satisfies FormFieldId] as string;
}

export function getInstrumentContractName(formValues: Collection<unknown>): string {
  return formValues['ProductSubtype' satisfies FormFieldId] as string;
}

export function buildRemunerationMode(formValues: Collection<unknown>): string {
  return formValues['RemunerationMode' satisfies FormFieldId] as string;
}
